<template>
  <div>
    <div class="hs1">
      <div class="name_s">{{ name }}专属</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: ""
    };
  },

  mounted() {
    this.name = this.$route.params.data;
  },
  methods: {}
};
</script>
<style lang="less" scoped>
* {
  font-size: 16px;
}

.hs1 {
  width: 100%;
  height: 13.34rem;
  background: url(../../assets/img/market/market110/券.png);
  background-size: 100% 100%;
  position: absolute;
}
.name_s {
  width: 5.38rem;
  height: 1rem;
  font-size: 0.42rem;
  font-weight: 600;
  line-height: 1rem;
  text-align: center;
  color: #fff9f1;
  position: relative;
  top: 4.55rem;
  left: 1.06rem;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/market/market103_success.vue